export default "__VITE_ASSET__DSryscus__"